import HeaderPage from "../../../shared/components/HeaderPage/HeaderPage";
import use123zapStore from "../../../context/123zapStore";

import ChannelAddContent from "./ChannelAddContent";
import { useChannelOptions } from "./useChannelOptions";

function ChannelPageAdd() {
  const featureAccess = use123zapStore((state) => state.featureAccess);

  const channelData = useChannelOptions(featureAccess);

  return (
    <>
      <HeaderPage title="Add WhatsApp Instance" />
      <ChannelAddContent channelData={channelData} isLoading={false} />
    </>
  );
}

export default ChannelPageAdd;
